<app-site-header />

<main class="app-shell">
  <router-outlet />
</main>

<app-site-footer />
